
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

interface SessionConflictDialogProps {
  isOpen: boolean;
  existingSession: {
    device: string;
    browser: string;
    last_active: string;
  } | null;
  onContinue: () => void;
  onCancel: () => void;
}

const SessionConflictDialog: React.FC<SessionConflictDialogProps> = ({
  isOpen,
  existingSession,
  onContinue,
  onCancel,
}) => {
  const lastActive = existingSession?.last_active 
    ? new Date(existingSession.last_active).toLocaleString() 
    : 'desconhecido';

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Sessão ativa detectada</AlertDialogTitle>
          <AlertDialogDescription>
            <p className="mb-2">Esta conta já está ativa em outro dispositivo ou navegador.</p>
            <p className="mb-2">
              <strong>Dispositivo:</strong> {existingSession?.device || 'Desconhecido'}
              <br />
              <strong>Navegador:</strong> {existingSession?.browser || 'Desconhecido'}
              <br />
              <strong>Última atividade:</strong> {lastActive}
            </p>
            <p className="text-destructive font-medium">É proibido usar a mesma conta em múltiplos dispositivos simultaneamente.</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            Sair e manter sessão existente
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button variant="destructive" onClick={onContinue}>
              Encerrar outra sessão e continuar
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SessionConflictDialog;
